module.exports = __webpack_public_path__ + "assets/adobe-dtm.9aad5224.svg";